export default __webpack_public_path__ + "static/media/pay_success.189d8de6.svg";